import * as Types from '../../../@types/graphql-types';

import gql from 'graphql-tag';
export type GetSportsFooterEventsV2QueryVariables = Types.Exact<{
	country: Types.Scalars['Country'];
	language: Types.Scalars['Language'];
	first: Types.Scalars['Int'];
	filter?: Types.Maybe<Types.SportEventFilter>;
	timezoneOffset: Types.Scalars['Int'];
}>;

export type GetSportsFooterEventsV2Query = { __typename?: 'Query' } & {
	sportEventsV2: { __typename?: 'SportEventsConnectionV2' } & {
		edges?: Types.Maybe<
			Array<
				{ __typename?: 'SportEventsEdgeV2' } & Pick<Types.SportEventsEdgeV2, 'cursor'> & {
						node:
							| ({ __typename?: 'MultiStepSportEvent' } & Pick<Types.MultiStepSportEvent, 'id'> & {
										content: { __typename?: 'MultiStepSportEventContent' } & Pick<
											Types.MultiStepSportEventContent,
											'name' | 'fullPath'
										>;
										competition?: Types.Maybe<
											{ __typename?: 'SportCompetitionV2' } & Pick<
												Types.SportCompetitionV2,
												'id'
											> & {
													content: { __typename?: 'SportCompetitionContentV2' } & Pick<
														Types.SportCompetitionContentV2,
														'name'
													>;
												}
										>;
									})
							| ({ __typename?: 'SingleStepSportEvent' } & Pick<Types.SingleStepSportEvent, 'id'> & {
										content: { __typename?: 'SingleStepSportEventContent' } & Pick<
											Types.SingleStepSportEventContent,
											'name' | 'fullPath'
										>;
										competition?: Types.Maybe<
											{ __typename?: 'SportCompetitionV2' } & Pick<
												Types.SportCompetitionV2,
												'id'
											> & {
													content: { __typename?: 'SportCompetitionContentV2' } & Pick<
														Types.SportCompetitionContentV2,
														'name'
													>;
												}
										>;
									});
					}
			>
		>;
	};
};

export const GetSportsFooterEventsV2Document = gql`
	query GetSportsFooterEventsV2(
		$country: Country!
		$language: Language!
		$first: Int!
		$filter: SportEventFilter
		$timezoneOffset: Int!
	) {
		sportEventsV2(country: $country, first: $first, filter: $filter, timezoneOffset: $timezoneOffset) {
			edges {
				cursor
				node {
					id
					content(country: $country, language: $language) {
						name
						fullPath
					}
					competition {
						id
						content(country: $country, language: $language) {
							name
						}
					}
				}
			}
		}
	}
`;
